// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see DirectDepositAccountIssueStartEvent
 */
export var DirectDepositAccountIssueStart = function () { return ({
    name: "DirectDepositAccount Issue Start",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Issue",
    }
}); };
/**
 * @see DirectDepositAccountIssueCompleteEvent
 */
export var DirectDepositAccountIssueComplete = function () { return ({
    name: "DirectDepositAccount Issue Complete",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Issue",
    }
}); };
/**
 * @see DirectDepositAccountEnableStartEvent
 */
export var DirectDepositAccountEnableStart = function (_a) {
    var clientScenario = _a.clientScenario, viewModal = _a.viewModal;
    return ({
        name: "DirectDepositAccount Enable Start",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "Enable",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_modal: viewModal !== undefined && viewModal !== null ? viewModal.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountEnableCompleteEvent
 */
export var DirectDepositAccountEnableComplete = function () { return ({
    name: "DirectDepositAccount Enable Complete",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Enable",
    }
}); };
/**
 * @see DirectDepositAccountViewStartEvent
 */
export var DirectDepositAccountViewStart = function (_a) {
    var appLocation = _a.appLocation;
    return ({
        name: "DirectDepositAccount View Start",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "View",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountViewLoadEvent
 */
export var DirectDepositAccountViewLoad = function (_a) {
    var section = _a.section;
    return ({
        name: "DirectDepositAccount View Load",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "View",
            section: section !== undefined && section !== null ? section.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountViewDismissEvent
 */
export var DirectDepositAccountViewDismiss = function () { return ({
    name: "DirectDepositAccount View Dismiss",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "View",
    }
}); };
/**
 * @see DirectDepositAccountViewCopyEvent
 */
export var DirectDepositAccountViewCopy = function (_a) {
    var copiedValue = _a.copiedValue;
    return ({
        name: "DirectDepositAccount View Copy",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "View",
            copied_value: copiedValue !== undefined && copiedValue !== null ? copiedValue.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountViewBenefitsStartEvent
 */
export var DirectDepositAccountViewBenefitsStart = function (_a) {
    var appLocation = _a.appLocation;
    return ({
        name: "DirectDepositAccount ViewBenefits Start",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "ViewBenefits",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountLoginStartEvent
 *
 * @deprecated No longer in use. Use the individual button events instead.
 */
export var DirectDepositAccountLoginStart = function (_a) {
    var launchLocation = _a.launchLocation;
    return ({
        name: "DirectDepositAccount Login Start",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "Login",
            launch_location: launchLocation !== undefined && launchLocation !== null ? launchLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountLoginSelectEvent
 */
export var DirectDepositAccountLoginSelect = function (_a) {
    var providerName = _a.providerName, providerType = _a.providerType, searchQuery = _a.searchQuery, token = _a.token;
    return ({
        name: "DirectDepositAccount Login Select",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "Login",
            provider_name: providerName !== undefined && providerName !== null ? providerName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            provider_type: providerType !== undefined && providerType !== null ? providerType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_query: searchQuery !== undefined && searchQuery !== null ? searchQuery.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            token: token !== undefined && token !== null ? token.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountLoginViewFormEvent
 */
export var DirectDepositAccountLoginViewForm = function (_a) {
    var searchQuery = _a.searchQuery;
    return ({
        name: "DirectDepositAccount Login ViewForm",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "Login",
            search_query: searchQuery !== undefined && searchQuery !== null ? searchQuery.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountTapStartGuidedSetupEvent
 */
export var DirectDepositAccountTapStartGuidedSetup = function () { return ({
    name: "DirectDepositAccount Tap StartGuidedSetup",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Tap",
    }
}); };
/**
 * @see DirectDepositAccountTapStartManualSetupEvent
 */
export var DirectDepositAccountTapStartManualSetup = function () { return ({
    name: "DirectDepositAccount Tap StartManualSetup",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Tap",
    }
}); };
/**
 * @see DirectDepositAccountTapEnterCompanyNameEvent
 */
export var DirectDepositAccountTapEnterCompanyName = function () { return ({
    name: "DirectDepositAccount Tap EnterCompanyName",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Tap",
    }
}); };
/**
 * @see DirectDepositAccountTapEmailFormEvent
 */
export var DirectDepositAccountTapEmailForm = function () { return ({
    name: "DirectDepositAccount Tap EmailForm",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Tap",
    }
}); };
/**
 * @see DirectDepositAccountTapViewFormEvent
 */
export var DirectDepositAccountTapViewForm = function () { return ({
    name: "DirectDepositAccount Tap ViewForm",
    parameters: {
        cdf_entity: "DirectDepositAccount",
        cdf_action: "Tap",
    }
}); };
/**
 * @see DirectDepositAccountSetAllocationStartEvent
 */
export var DirectDepositAccountSetAllocationStart = function (_a) {
    var source = _a.source, isSkipped = _a.isSkipped;
    return ({
        name: "DirectDepositAccount SetAllocation Start",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "SetAllocation",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_skipped: isSkipped !== undefined && isSkipped !== null ? isSkipped.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountSetAllocationAdjustAmountEvent
 */
export var DirectDepositAccountSetAllocationAdjustAmount = function (_a) {
    var source = _a.source;
    return ({
        name: "DirectDepositAccount SetAllocation AdjustAmount",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "SetAllocation",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DirectDepositAccountCompleteManualFlowCreateDirectDepositFormEvent
 */
export var DirectDepositAccountCompleteManualFlowCreateDirectDepositForm = function (_a) {
    var documentToken = _a.documentToken;
    return ({
        name: "DirectDepositAccount CompleteManualFlow CreateDirectDepositForm",
        parameters: {
            cdf_entity: "DirectDepositAccount",
            cdf_action: "CompleteManualFlow",
            document_token: documentToken !== undefined && documentToken !== null ? documentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
